<template>
  <div class="over-view-container">
    <div class="jc-page-top">
      <div class="instance-list">
        <div class="jc-page-header">
          <h1>
            <i class="jc-icon-my-circle-bold"></i>{{$t('text.overview')}}
          </h1>
        </div>
        <div class="jc-page-content">
          <div class="el-section">
            <div class="el-section-content el-content-to-top">
              <el-button class="el-button-icon el-button-icon-refresh"
                         icon="jc-icon-refresh-line"
                         @click="refreshOverviewCards"
                         ></el-button>
              <!-- <el-radio-group v-model="selectRoom"
                              @change="idcChange">
                <el-radio-group-advance :max-shown-count="5" more-trigger="click" :more-label="$t('text.moreNode')">
                  <el-radio-button v-for="room in computerRoom"
                                 :key="room.id"
                                 :label="room.id"
                    >{{ room.region }}</el-radio-button
                  >
                </el-radio-group-advance>
              </el-radio-group> -->
              <el-select v-model="selectTitle" @change="titleChange" clearable :placeholder="$t('placeholder.choose')">
                <el-option
                  v-for="title in searchTitleArray"
                  :key="title.id"
                  :value="title.id"
                  :label="title.name">
                </el-option>
              </el-select>
              <!-- 托管区 选择框 -->
              <el-select v-model="selectRoom" @change="idcChange" :placeholder="$t('placeholder.choose')" v-if="selectTitle === 2">
                <!-- 全部 -->
                <el-option
                  :key="AllId"
                  :value="AllId"
                  :label="$t('ticket.complete')">
                </el-option>
                <el-option
                  v-for="room in computerRoom"
                  :key="room.regionEn"
                  :value="room.regionEn"
                  :label="room.regionShow">
                </el-option>
              </el-select>
              <!-- 机房名称 选择框 -->
              <el-select v-model="selectRoom" @change="idcChange" :placeholder="$t('placeholder.choose')" v-if="selectTitle === 1">
                <el-option
                  :key="AllId"
                  :value="AllId"
                  :label="$t('ticket.complete')">
                </el-option>
                <el-option
                  v-for="roomName in computerRoom"
                  :key="roomName.regionEn"
                  :value="roomName.regionEn"
                  :label="roomName.datacenterNameShow">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="el-section">
            <h3 class="body-title-h3">{{ $t('overview.resourceInformation') }}</h3>
            <div class="el-section-content el-overview-section-content">
              <div v-loading="refreshLoading"
                   id="loadingArea">
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-card>
                      <h3 class="card-title-h3">{{ $t('overview.cabinetInformation') }}</h3>
                      <el-row :gutter="10"
                              class="content-to-title">
                        <el-col :span="6">
                          <div class="card-left-box"
                               @click="jumpToPage('cabinet')">
                            <a href="javascript:void(0)"
                               class="left-big-box-a">{{ cabinet.sum }}</a>
                            <span class="left-big-box-span">{{ $t('overview.cabinetTotal') }}</span>
                          </div>
                        </el-col>
                        <el-col :span="18">
                          <el-row :gutter="18"
                                  class="second-right-row-to-row">
                            <el-col :span="12">
                              <div class="one-card-right-box"
                                   @click="jumpToPage('cabinet', 'enabled')">
                                <span class="second-card-right-span">{{ $t('overview.Enabled')
                                  }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ cabinet.enabled }}</a>
                              </div>
                            </el-col>
                            <el-col :span="12">
                              <div class="one-card-right-box"
                                   @click="jumpToPage('cabinet', 'disabled')">
                                <span class="second-card-right-span">{{
                                  $t('overview.Disabled') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ cabinet.disabled }}</a>
                              </div>
                            </el-col>
                          </el-row>
                          <el-row :gutter="18"
                                  class="second-right-row-to-row">
                            <el-col :span="12">
                              <div class="one-card-right-box"
                                   @click="jumpToPage('cabinet', 'enabling')">
                                <span class="second-card-right-span">{{
                                  $t('overview.Enabling') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ cabinet.enabling }}</a>
                              </div>
                            </el-col>
                            <el-col :span="12">
                              <div class="one-card-right-box"
                                   @click="jumpToPage('cabinet', 'disabling')">
                                <span class="second-card-right-span">{{
                                  $t('overview.Disabling') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ cabinet.disabling }}</a>
                              </div>
                            </el-col>
                          </el-row>
                       </el-col>
                      </el-row>
                    </el-card>
                  </el-col>
                  <el-col :span="12">
                    <el-card>
                      <h3 class="card-title-h3">{{ $t('overview.equipmentInformation') }}</h3>
                      <el-row :gutter="10"
                              class="content-to-title">
                        <el-col :span="6">
                          <div class="card-left-box"
                               @click="jumpToPage('equipment')">
                            <a href="javascript:void(0)"
                               class="left-big-box-a">{{ device.sum }}</a>
                            <span class="left-big-box-span">{{ $t('overview.equipmentTotal') }}</span>
                          </div>
                        </el-col>
                        <el-col :span="18">
                          <el-row :gutter="10"
                                  class="second-right-row-to-row">
                            <el-col :span="6">
                              <div class="card-right-small-box"
                                   @click="jumpToPage('equipment', 'server')">
                                <span class="second-card-right-span">{{ $t('overview.severTotal')
                                  }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ device.server }}</a>
                              </div>
                            </el-col>
                            <el-col :span="6">
                              <div class="card-right-small-box"
                                   @click="jumpToPage('equipment', 'network')">
                                <span class="second-card-right-span">{{
                                  $t('overview.networkEquipmentTotal') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ device.network }}</a>
                              </div>
                            </el-col>
                            <el-col :span="6">
                              <div class="card-right-small-box"
                                   @click="jumpToPage('equipment', 'storage')">
                                <span class="second-card-right-span">{{
                                  $t('overview.storageEquipmentTotal') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ device.storage }}</a>
                              </div>
                            </el-col>
                            <el-col :span="6">
                              <div class="card-right-small-box"
                                   @click="jumpToPage('equipment', 'other')">
                                <span class="second-card-right-span">{{
                                  $t('overview.othersEquipmentTotal') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ device.other }}</a>
                              </div>
                            </el-col>
                          </el-row>
                          <el-row :gutter="10"
                                  class="second-right-row-to-row">
                            <el-col :span="6">
                              <div class="card-right-small-box"
                                   @click="jumpToPage('equipment', 'opened')">
                                <span class="second-card-right-span">{{
                                  $t('overview.Enabled') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ device.opened }}</a>
                              </div>
                            </el-col>
                            <el-col :span="6">
                              <div class="card-right-small-box"
                                   @click="jumpToPage('equipment', 'launched')">
                                <span class="second-card-right-span">{{
                                  $t('text.onShelf') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ device.launched }}</a>
                              </div>
                            </el-col>
                          </el-row>
                          <el-row :gutter="10">
                            <el-col :span="6">
                              <div class="card-right-small-box"
                                   @click="jumpToPage('equipment', 'operating')">
                                <span class="second-card-right-span">{{ $t('overview.operating') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ device.operating }}</a>
                              </div>
                            </el-col>
                            <el-col :span="6">
                              <div class="card-right-small-box"
                                   @click="jumpToPage('equipment', 'modifying')">
                                <span class="second-card-right-span">{{ $t('overview.changing') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ device.modifying }}</a>
                              </div>
                            </el-col>
                            <el-col :span="6">
                              <div class="card-right-small-box"
                                   @click="jumpToPage('equipment', 'canceling')">
                                <span class="second-card-right-span">{{ $t('overview.unsubscribing') }}</span>
                                <a href="javascript:void(0)"
                                   class="second-card-right-a">{{ device.canceling }}</a>
                              </div>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-card>
                  </el-col>

                </el-row>
                <el-row :gutter="15"
                        class="second-row">
                  <el-col :span="12">
                    <el-card>
                      <h3 class="card-title-h3">{{ $t('overview.publicNetIpInformation') }}</h3>
                      <el-row :gutter="10"
                              class="content-to-title">
                        <el-col :span="6">
                          <div class="card-left-box"
                               @click="jumpToPage('ip')">
                            <a href="javascript:void(0)"
                               class="left-big-box-a">{{ ip.sum }}</a>
                            <span class="left-big-box-span">{{ $t('overview.ipTotal') }}</span>
                          </div>
                        </el-col>
                        <el-col :span="18">
                          <el-row>
                            <div class="card-right-big-box"
                                 @click="jumpToPage('ip', {status:'normal'})">
                              <span class="right-big-box-span">{{ $t('text.normal') }}</span>
                              <a class="right-big-box-a"
                                 href="javascript:void(0)">{{ ip.normal }}</a>
                            </div>
                          </el-row>
                          <el-row class="right-col-to-col">
                            <div class="card-right-big-box"
                                 @click="jumpToPage('ip', {status:'abnormal'})">
                              <span class="right-big-box-span">{{ $t('text.abnormal') }}</span>
                              <a class="right-big-box-a"
                                 href="javascript:void(0)">{{ ip.abnormal }}</a>
                            </div>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-card>
                  </el-col>
                  <el-col :span="12">
                    <el-card>
                      <h3 class="card-title-h3">{{ $t('overview.bandWidthInformation') }}</h3>
                      <el-row class="content-to-title" :gutter="12">
                        <el-col v-for="(value, key, index) in bandWidth"
                                :key="index" :span="12">
                          <div class="card-last-box"
                               @click="jumpToPage('bandWidth', {lineTypeConsole: key})">
                            <span class="last-card-span">{{ transformKey(key) }}</span>
                            <a class="last-card-a"
                               href="javascript:void(0)">{{ value }}</a>
                          </div>
                        </el-col>
                      </el-row>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <!-- 报警信息 -->
          <alarm-info :alarmList="alarmList"
                      v-if="GLOBAL.IDCLINE == '1'"
                      :loading="alarmLoading"
                      :idcId="selectRoom"></alarm-info>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatLocale } from '@/localeUtil';
import alarmInfo from './sub/AlarmInfo';
import { handleChangeAllSelectedValue, AllSelectOption, AllId } from '@/utils/common/index'

export default {
  name: 'overView',
  components: { alarmInfo },
  data () {
    return {
      AllId,
      selectRoom: AllId,
      refreshLoading: false,
      // computerRoom: [AllSelectOption(this, 'id', 'region')],
      computerRoom: [],
      cabinet: {},
      device: {},
      ip: {},
      bandWidth: {},
      alarmLoading: false, // 报警信息Loading
      alarmList: [], // 报警信息列表
      selectTitle: 1,
      searchTitleArray: [
        // {
        //     id: '',
        //     name: this.$t('ticket.complete')
        // },
        {
            id: 1,
            name: this.$t('cabinet.roomName') // 机房名称
        },
        {
            id: 2,
            name: this.$t('idcs.region') // 托管区
        }
      ],
      roomNameArr: [],
    };
  },
  methods: {
    refreshOverviewCards () {
      this.refreshLoading = true;
      this.getIdcOverview();
      // 刷新报警信息
      this.getAlarmInfo();
    },
    getComputerRooms () {
      const param = {
        all: 1, idcLine: this.GLOBAL.IDCLINE
      };
      this.$api.getComputerRoom(param).then((response) => {
        // let response = JSON.parse(res);
        if (response.errno === 10000 && response.data.idcs) {
          if (response.data.idcs.length > 0) {
            response.data.idcs.forEach((idc) => {
              const idcObj = {};
              if (idc.idc) {
                // idcObj.region = idc.idcName;
                // idcObj.id = idc.idc;

                const { regionShow, datacenterNameShow, regionEn } = idc;
                idcObj.regionShow = regionShow;
                idcObj.regionEn = regionEn;
                idcObj.datacenterNameShow = datacenterNameShow;
                this.computerRoom.push(idcObj);
              }
            });
          }
        }
        if (this.computerRoom.length !== 0) {
          this.$nextTick(() => {
            // this.selectRoom = this.computerRoom[0].id;
            this.selectRoom = AllId
            this.getIdcOverview();
            this.getAlarmInfo();
          })
        }
      });
    },
    getIdcOverview () {
      if (!this.needRequireResource) {
        return;
      }
      let param = {
        // idc: this.selectRoom,
        regionEn: this.selectRoom && this.selectRoom !== 'all' ? this.selectRoom : '',
      };
      // 选择下拉筛选的“全部”all
      // param = {...param, ...handleChangeAllSelectedValue(this.selectRoom)}
      this.$api.getIdcOverview(param).then((response) => {
        // let response = JSON.parse(res);
        if (response.errno === 10000 && response.data) {
          const resData = response.data;
          this.cabinet = resData.cabinet;
          this.device = resData.device;
          this.ip = resData.ip;
          const isps = ['dynamicBGP', 'thirdLineBGP', 'telecom', 'unicom', 'mobile'];
          isps.forEach((isp) => {
            this.bandWidth[isp] = resData.bandwidth[isp];
          });
        }
        this.refreshLoading = false;
      });
    },

    // 获取报警信息
    getAlarmInfo () {
      if (!this.needRequireResource) {
        return;
      }
      // 查询最近5条报警历史
      let param = {
        // idc: this.selectRoom,
        pageNumber: 1,
        pageSize: 5,
      };
      if (this.selectRoom && this.selectRoom !== 'all') {
        param = { ...param, regionEn: this.selectRoom };
      }
      // 选择下拉筛选的“全部”all
      // param = {...param, ...handleChangeAllSelectedValue(this.selectRoom)}
      this.alarmLoading = true;
      this.$api.getAlarmHistoryList(param).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK' && res.data) {
          this.alarmList = res.data.alarmHistory;
        }
      }).catch(() => {
        this.alarmList = [];
      }).finally(() => {
        this.alarmLoading = false;
      });
    },

    transformKey (value) {
      let realVal;
      switch (value) {
        case 'dynamicBGP':
          realVal = this.$t('text.dynamicBGP');
          break;
        case 'thirdLineBGP':
          realVal = this.$t('text.thirdLineBGP');
          break;
        case 'telecom':
          realVal = this.$t('text.Telecom');
          break;
        case 'unicom':
          realVal = this.$t('text.Unicom');
          break;
        case 'mobile':
          realVal = this.$t('text.Mobile');
          break;
      }
      return realVal;
    },

    titleChange (value) {
      this.selectRoom = this.AllId;
      this.getIdcOverview();
      this.getAlarmInfo();
    },

    idcChange (value) {
      this.refreshLoading = true;
      this.selectRoom = value;
      this.getIdcOverview();
      // 切换idc重新加载报警信息
      this.getAlarmInfo();
    },

    jumpToPage (type) {
      const query = {};
      if (arguments[1] !== undefined) {
        Object.keys(arguments[1]).forEach((key) => {
          query[key] = arguments[1][key];
        });
      }
      if (this.selectRoom !== 0) {
        query.selectRoom = this.selectRoom;
      }
      if (type == 'ip') {
        this.$router.push({
          path: '/ipAddress/list',
          query
        });
      } else if (type == 'bandWidth') {
        this.$router.push({
          path: '/bandWidth/list',
          query
        });
        return;
      }
      switch (type) {
        case 'cabinet':
          this.$router.push({
            path: '/cabinet/list',
            query: {
              selectRoom: this.selectRoom === 0 ? undefined : this.selectRoom,
              cabinetOpenStatus: arguments[1] === undefined ? undefined : arguments[1]
            }
          });
          break;
        case 'equipment':
          this.$router.push({
            path: '/equipment/list',
            query: {
              selectRoom: this.selectRoom === 0 ? undefined : this.selectRoom,
              currentParam: arguments[1] === undefined ? 'all' : arguments[1]
            }
          });
          break;
      }
    }
  },
  computed: {
    needRequireResource () {
      return !!this.selectRoom;
    },
    // 计算属性的 getter
    lang () {
      // `this` 指向 vm 实例
      return formatLocale(this.$cookie.get('jdcloud_sitelang'));
    }
  },
  // watch: {
  //   selectRoom (newVal, oldVal) { }
  // },
  created () {
    this.getComputerRooms();
    /*
       * 当用户名下没有机房时
       * 不发送请求，为了在页面有对应显示
       */
    if (JSON.stringify(this.bandWidth) === '{}') {
      const isps = ['dynamicBGP', 'thirdLineBGP', 'telecom', 'unicom', 'mobile'];
      isps.forEach((isp) => {
        this.bandWidth[isp] = '';
      });
    }
  },
};
</script>

<style lang="scss">
@import "./overView.scss";
</style>



// WEBPACK FOOTER //
// src/components/resourceOverview/OverView.vue